module.exports = __webpack_public_path__ + "static/media/31-nights-of-horror-2019-logo.65a5ab18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/31-nights-of-horror-2019-logo.svg
// module id = 300
// module chunks = 0